import React from "react"
import { IntegracaoFoodyDeliveryInicial, type IntegracaoFoodyDeliveryModel } from "../models/integracaoFoodyDeliveryModel"
import type { IntegracaoFoodyDeliveryActions } from "./integracaoFoodyDeliveryActions"

type ContextType = {
    dados: IntegracaoFoodyDeliveryModel
    dispatch: React.Dispatch<IntegracaoFoodyDeliveryActions>
    erroCarregamento: string | null
    salvarToken: () => Promise<void>
    testarIntegracao: () => Promise<void>
    limparErros: () => Promise<void>
}

export const IntegracaoFoodyDeliveryContext = React.createContext<ContextType>({
    dados: IntegracaoFoodyDeliveryInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    salvarToken: async () => undefined,
    testarIntegracao: async () => undefined,
    limparErros: async () => undefined,
})
